import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { LIST_NOTI_HEADER_TABLE } from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';
import { DeleteNotificationComponent } from '../deleteNotifaction/deleteNotification.component';

@Component({
  selector: 'app-list-notification',
  templateUrl: './list-notification.component.html',
  styleUrls: ['./list-notification.component.scss'],
})
export class ListNotificationComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  @Input() reSieze: boolean;
  @Output() public totalItemsList = new EventEmitter<number>();

  public displayedColumns = LIST_NOTI_HEADER_TABLE;
  public dataSource = new MatTableDataSource([]);
  public listData: any;
  public page: number = 1;
  public limit: number = 10;
  public itemsPerPage: number;
  public pageIndex: number = 0;
  public length: number = 0;
  public pageEvent: PageEvent;
  public noImageUrl: string = 'assets/images/noti-image.png';
  public todayIsPassingDateToSendNotification: boolean = false;
  public statusDetail: RequestStatus = 'init';

  constructor(
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.notificationService
      .listNotification('', this.page, this.limit)
      .pipe(tap(() => (this.statusDetail = 'success')))
      .subscribe((rta: any) => {
        const { ItemsPage, totalItems, currentPage, find } = rta;
        this.itemsPerPage = ItemsPage;
        this.length = totalItems;
        this.pageIndex = currentPage - 1;
        this.dataSource.data = find;
        this.sendTotalItemsList(totalItems);
      });
    this.notificationService.Refreshrequired.subscribe(() => {
      this.getListNotifications('', this.page, this.limit);
    });
  }

  private getListNotifications(
    search: string,
    page: number,
    limit: number
  ): void {
    this.subs.sink = this.notificationService
      .listNotification(search, page, limit)
      .subscribe((rta: any) => {
        const { find } = rta;
        this.listData = find;
        this.dataSource = find;
      });
  }

  public goToEditNotification(element: any): void {
    if (!this.enableEdit(element)) return;

    this.router.navigate([`notifications/edit-notification/${element._id}`]);
  }

  public enableEdit(element: any): boolean {
    return element.programming != 'now' && element.sent == false;
  }

  public notificationDeleted(id: string): void {
    this.subs.sink = this.notificationService
      .deleteNotification(id)
      .subscribe();
  }

  public handlePageEvent(e: PageEvent): void {
    e.pageIndex >= 0 ? this.loadMoreItems(e.pageIndex + 1) : null;
  }

  public openDialog(id: string): void {
    let dialogRef = this.dialog.open(DeleteNotificationComponent, {
      width: '456px',
      height: '208px',
      disableClose: true,
    });
    this.subs.sink = dialogRef.afterClosed().subscribe((result: any) => {
      result == true ? this.deleteNotiSucces(id) : null;
    });
  }

  public loadMoreItems(page: number): void {
    this.subs.sink = this.notificationService
      .listNotification('', page, this.limit)
      .subscribe((rta: any) => {
        const { find } = rta;
        this.dataSource.data = find;
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public filterNotificationByTime(valor: any): boolean {
    const lastDateFromNotificaton = valor.split('T')[0];
    return Date.parse(new Date().toDateString()) >
      Date.parse(lastDateFromNotificaton)
      ? true
      : false;
  }

  public sendTotalItemsList(value: number): void {
    this.totalItemsList.emit(value);
  }

  private deleteNotiSucces(id: string): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['NOTIFICATIONS.noti-deleted-with-succses', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['NOTIFICATIONS.noti-deleted-with-succses'];
        const action = valor['USERS.undo'];
        this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        this._snackBar._openedSnackBarRef?.onAction().subscribe(() => {
          change = false;
        });

        this._snackBar._openedSnackBarRef?.afterDismissed().subscribe(() => {
          if (change === true) {
            this.notificationDeleted(id);
          }
        });
      });
  }

  public sortingByTitle() {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.notification_title.toUpperCase();
      const nameB = b.notification_title.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    this.dataSource.data = newOrder;
  }

  public sortByTitledown(): any {
    let newOrder = this.dataSource.data.sort((a: any, b: any) => {
      const nameA = a.notification_title.toUpperCase();
      const nameB = b.notification_title.toUpperCase();
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
    this.dataSource.data = newOrder;
  }
}
